import { render, staticRenderFns } from "./consumption.vue?vue&type=template&id=207aa0b8&"
import script from "./consumption.vue?vue&type=script&lang=js&"
export * from "./consumption.vue?vue&type=script&lang=js&"
import style0 from "./consumption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports